var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7437 18.8593H19.0686",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7437 15.6968H19.0686",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 7.79062H23.2C23.4122 7.79062 23.6157 7.87307 23.7657 8.01984C23.9157 8.16661 24 8.36567 24 8.57323V25.008C24 25.2156 23.9157 25.4146 23.7657 25.5614C23.6157 25.7082 23.4122 25.7906 23.2 25.7906H8.8C8.58783 25.7906 8.38434 25.7082 8.23431 25.5614C8.08429 25.4146 8 25.2156 8 25.008V8.57323C8 8.36567 8.08429 8.16661 8.23431 8.01984C8.38434 7.87307 8.58783 7.79062 8.8 7.79062H12.8",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9531 10.9531V10.1625C11.9531 9.11405 12.3696 8.10857 13.111 7.36722C13.8523 6.62587 14.8578 6.20938 15.9062 6.20938C16.9547 6.20938 17.9601 6.62587 18.7015 7.36722C19.4428 8.10857 19.8593 9.11405 19.8593 10.1625V10.9531H11.9531Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatements);
export default __webpack_public_path__ + "static/media/Statements.d5336d2bb5ef0407c330c858c9a7d22b.svg";
export { ForwardRef as ReactComponent };